import React from "react";
import { Code2, Search, Sparkles, Link2, Target } from "lucide-react";

const SERVICES = [
  {
    icon: Code2,
    title: "SEO-Focused Website Development",
    bullets: [
      "Mobile-friendly responsive design",
      "Fast-loading pages",
      "SEO-ready structure",
      "Clean and scalable code",
      "Core Web Vitals optimization",
    ],
  },
  {
    icon: Search,
    title: "Affordable SEO Services in USA",
    bullets: [
      "High-intent keyword targeting",
      "Content optimization",
      "Technical SEO improvements",
      "Internal linking strategy",
      "Organic traffic growth",
    ],
  },
  {
    icon: Sparkles,
    title: "AI Platform Ranking & Visibility",
    bullets: [
      "AI search ecosystems",
      "AI-generated answer platforms",
      "Semantic search systems",
      "Structured content optimization",
      "Entity-based SEO strategies",
    ],
  },
  {
    icon: Link2,
    title: "Link Building & Authority Growth",
    bullets: [
      "Niche-relevant backlinks",
      "Guest posting campaigns",
      "Authority outreach",
      "Brand mention strategies",
      "High-quality backlink acquisition",
    ],
  },
  {
    icon: Target,
    title: "Conversion-Focused Marketing",
    bullets: [
      "Landing page improvements",
      "Better user experience",
      "Conversion tracking",
      "Funnel optimization",
      "Lead-focused website structure",
    ],
  },
];

export const Services = () => {
  return (
    <section id="services" className="relative py-24 lg:py-32 bg-lilac">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 rounded-full bg-white px-3.5 py-1 text-xs font-medium text-brand-deep border border-[hsl(var(--brand-violet)/.15)]">
            What We Offer
          </div>
          <h2 className="mt-4 text-4xl sm:text-5xl font-bold text-[hsl(var(--brand-navy))]">
            Website development, SEO & AI visibility - <span className="text-gradient-brand">under one roof</span>
          </h2>
          <p className="mt-4 text-slate-600 text-base sm:text-lg leading-relaxed">
            Many businesses invest in design or SEO separately, which creates problems later. We combine them from day one so you get a website that ranks, performs and converts.
          </p>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                data-testid={`service-card-${i}`}
                className="group relative rounded-3xl bg-white p-7 border border-black/5 card-shadow hover:card-shadow-hover transition-all duration-500 hover:-translate-y-1"
              >
                <div className="absolute -top-3 -right-3 h-10 w-10 rounded-2xl brand-gradient grid place-items-center opacity-90 group-hover:rotate-6 transition-transform">
                  <Icon className="h-5 w-5 text-white" />
                </div>
                <div className="text-xs font-mono text-brand">0{i + 1}</div>
                <h3 className="mt-2 text-xl font-semibold text-[hsl(var(--brand-navy))]">{s.title}</h3>
                <ul className="mt-4 space-y-2">
                  {s.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-2 text-sm text-slate-600">
                      <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-[hsl(var(--brand-amber))]" />
                      {b}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
